import { render, staticRenderFns } from "./OrganizerListItem.vue?vue&type=template&id=e4bd912c&"
import script from "./OrganizerListItem.vue?vue&type=script&lang=js&"
export * from "./OrganizerListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4bd912c')) {
      api.createRecord('e4bd912c', component.options)
    } else {
      api.reload('e4bd912c', component.options)
    }
    module.hot.accept("./OrganizerListItem.vue?vue&type=template&id=e4bd912c&", function () {
      api.rerender('e4bd912c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Invitees/OrganizerListItem.vue"
export default component.exports